<app-nav></app-nav>
<section class="chat-section">
  <div class="container">
    <div class="col">
      <form name="emailForm" (ngSubmit)="formEmail.emailForm.valid" #formEmail="ngForm">
          <div id="chatBoxWindow" class="chat-box maximized">

             
            
              <!-- Chat container -->
              <div class="container">
                <div id="chatProcess" class="chat">
            
                  <!-- <div class="spinner"></div> -->
            
                  <div class="scroll-chat">
                    <ul id="scrollChat">
                      <li class="receive welcome"><span>Hi! Welcome to SecureNow!</span></li>
                      <li class="receive question user-name"><span>May I know your name?</span></li>
                      <li class="sent"><span>Gagan</span></li>
                      <li class="receive"><span>Hi Gagan, how can I help you?</span></li>
                    </ul>
                  </div>
            
                  <div class="input-box">
            
                    <!-- Textbox -->
                    <input type="text" name="" placeholder="Type here.." id="textBox">
            
                    <!-- Question Buttons -->
                    <div class="bottom-buttons hide"></div>
            
                    <!-- Send button -->
                    <button type="button" id="sendButton" disabled>
                      <span class="send"></span>
                      <span class="done"></span>
                      <span class="pass"></span>
                    </button>
            
                  </div>
            
                </div>
            
                <!-- Thank you message -->
                <div id="thankYouMsg" class="chat" style="display: none">
                  <img src="https://s3.ap-south-1.amazonaws.com/static-files-website/common-images/securenow-logo-large.png" class="chat-logo">
                  <hr>
                  <div class="thankYou">
                    <h2>Thanks</h2>
                    <p>We will contact you shortly to discuss further.</p>
                  </div>
                </div>
              </div>
            </div>
      </form>
    </div>
  </div>
</section>
<section class="footer">
  <div class="fixed-footer">
    <div class="row footer-body">
      <div class="col text-center p-0" routerLink="/home" ><img src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/Home-bordered.svg" class="img img-fluid" alt=""></div>
      <div class="col text-center p-0"><a href="tel:+919696683999"><img src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/phone-bordered.svg" class="img img-fluid" alt=""></a></div>
      <div class="col text-center p-0"><img src="https://static-files-website.s3.ap-south-1.amazonaws.com/common-images/email-bordered.svg" class="img img-fluid" alt=""></div>
      <div class="col text-center p-0" routerLink="/profile" ><img src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/comment-2.svg" class="img img-fluid" alt=""></div>
      <div class="col text-center p-0" routerLink="/notifications-new" ><img src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/alarm-bordered.svg" class="img img-fluid" alt=""></div>
    </div>
  </div>
</section>